export const testimonialsData = [
  {
    name: 'Stephanie R.',
    imgUrl: 'https://si.keen.com/D1_homepage-testimonialman1_V1.png',
    text: 'During times when I have been happy, frustrated, sad, any emotion fathomable, I have always been shown light by gifted advisors on this priceless site.'
  },
  {
    name: 'Brian C.',
    imgUrl: 'https://si.keen.com/D1_homepage-testimonialman2_V1.png',
    text: 'My psychic advisors have led me through tough times with great advice, care, light and love.'
  }
];

export default testimonialsData;
